<template>
  <div class="fragment">
    <div class="order-create__section-label section-label"
         v-bind:class="{'admin-edit-item': isAdmin || checkImpersonate()}">
      <div class="admin-edit" @click="editTranslate(['expenses_ExpensesDetails'])"></div>
      {{$t('expenses_ExpensesDetails.localization_value.value')}}
    </div>

    <!--<div class="order-create__product custom-row">-->
      <!--<div class="order-create__product-col custom-col custom-col&#45;&#45;50 custom-col&#45;&#45;md-50 custom-col&#45;&#45;sm-100"-->
           <!--v-bind:class="{'admin-edit-item': isAdmin || checkImpersonate()}">-->
        <!--<div class="admin-edit" @click="editTranslate(['expenses_ExpenseName'])"></div>-->
        <!--<DefaultInput-->
                <!--v-bind:class="{'ui-no-valid': EX.validation.name}"-->
                <!--:error="EX.validation.name"-->
                <!--:errorTxt="$t(`${EX.validationTranslate.name}.localization_value.value`)"-->
                <!--:label="$t('expenses_ExpenseName.localization_value.value')"-->
                <!--:type="'text'"-->
                <!--v-model="EX.data.name"-->
        <!--/>-->
      <!--</div>-->
    <!--</div>-->

    <div class="order-create__product custom-row">
      <div class="custom-col custom-col--50 custom-col--sm-100"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate([
      'expenses_warehouse',
      ])"></div>
        <DefaultSelect
            :options="warehouses"
            :optionsLabel="'name'"
            :label="$t('expenses_warehouse.localization_value.value')"
            v-bind:class="{'ui-no-valid': EX.validation.warehouse}"
            :errorTxt="$t(`${EX.validationTranslate.warehouse}.localization_value.value`)"
            :error="EX.validation.warehouse"
            :otherValue="'currentTranslation'"
            @change="(val) => {EX.setWarehouse(val)}"
            :selected="EX.data.warehouse"
        />
      </div>

      <div class="order-create__product-col custom-col custom-col--50 custom-col--md-50 custom-col--sm-100"
           v-bind:class="{'admin-edit-item': isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['expenses_TypeExpenses'])"></div>
        <DefaultSelect
            :options="expenseTypes"
            :label="$t('expenses_TypeExpenses.localization_value.value')"
            :optionsLabel="'name'"
            v-bind:class="{'ui-no-valid': EX.validation.type}"
            :errorTxt="$t(`${EX.validationTranslate.type}.localization_value.value`)"
            :error="EX.validation.type"
            :selected="EX.data.type"
            @change="changeExpensesType"
        />
      </div>

      <div class="order-create__product-col custom-col custom-col--50 custom-col--md-50 custom-col--sm-100"
           v-if="_.has(EX.data.type, 'children') && EX.data.type.children.length > 0"
           v-bind:class="{'admin-edit-item': isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['expenses_TypeExpensesChildren'])"></div>
        <DefaultSelect
            :options="EX.data.type.children"
            :label="$t('expenses_TypeExpensesChildren.localization_value.value')"
            :optionsLabel="'name'"
            v-bind:class="{'ui-no-valid': EX.validation.typeChild}"
            :errorTxt="$t(`${EX.validationTranslate.typeChild}.localization_value.value`)"
            :error="EX.validation.typeChild"
            :selected="EX.data.typeChild"
            @change="changeExpensesTypeChild"
        />
      </div>
    </div>

    <div class="order-create__product custom-row">
      <div class="order-create__product-col custom-col custom-col--50 custom-col--md-50 custom-col--sm-100"
           v-bind:class="{'admin-edit-item': isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['expenses_DocumentDate'])"></div>
        <DatePickerDefault
                :label="$t('expenses_DocumentDate.localization_value.value')"
                :value="EX.data.documentDate"
                v-bind:class="{'ui-no-valid': EX.validation.documentDate}"
                :errorTxt="$t(`${EX.validationTranslate.documentDate}.localization_value.value`)"
                :error="EX.validation.documentDate"
        >
          <template slot="body">
            <date-picker
                    v-model="EX.data.documentDate"
                    valueType="format"
                    :lang="$store.getters.getDatePickerTranslations[$store.getters.GET_LANG]"
            ></date-picker>
          </template>
        </DatePickerDefault>
      </div>

      <div class="order-create__product-col custom-col custom-col--50 custom-col--md-50 custom-col--sm-100"
           v-bind:class="{'admin-edit-item': isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['expenses_payee'])"></div>
        <DefaultSelect
            :options="payees"
            :label="$t('expenses_payee.localization_value.value')"
            :optionsLabel="'name'"
            v-bind:class="{'ui-no-valid': EX.validation.payee}"
            :errorTxt="$t(`${EX.validationTranslate.payee}.localization_value.value`)"
            :error="EX.validation.payee"
            :selected="EX.data.payee"
            @change="changeExpensesPayee"
        />
      </div>
    </div>


    <div class="order-create__product custom-row">
      <div class="custom-col custom-col--75 custom-col--md-100"
           v-bind:class="{'admin-edit-item': isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['expenses_Comment'])"></div>
        <TextareaDefault
                :label="$t('expenses_Comment.localization_value.value')"
                v-bind:class="{'ui-no-valid': EX.validation.comment}"
                :error="EX.validation.comment"
                :errorTxt="$t(`${EX.validationTranslate.comment}.localization_value.value`)"
                v-model="EX.data.comment"
        />
      </div>

      <div class="order-create__product-col custom-col custom-col--16 custom-col--md-33  custom-col--sm-50"
           v-bind:class="{'admin-edit-item': isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['expenses_Total'])"></div>
        <InputSum
            v-bind:class="{'ui-no-valid': EX.validation.total}"
            :error="EX.validation.total"
            :errorTxt="$t(`${EX.validationTranslate.total}.localization_value.value`)"
            :label="$t('expenses_Total.localization_value.value')"
            :placeholder="'0'"
            :icoType="'dollar'"
            v-model="EX.data.total"
        />
      </div>
    </div>

    <div class="order-create__product custom-row">
      <div class="custom-col custom-col--50 custom-col--sm-100"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate([
      'common_country',
      ])"></div>
        <DefaultSelect
            :options="countries"
            :optionsLabel="'name'"
            :label="$t('common_country.localization_value.value')"
            v-bind:class="{'ui-no-valid': EX.validation.country}"
            :errorTxt="$t(`${EX.validationTranslate.country}.localization_value.value`)"
            :error="EX.validation.country"
            :otherValue="'currentTranslation'"
            @change="(val) => {EX.setCountry(val)}"
            :selected="EX.data.country"
        />
      </div>

      <div class="custom-col custom-col--50 custom-col--sm-100"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate([
      'expenses_bank',
      ])"></div>
        <DefaultSelect
            :options="banks"
            :optionsLabel="'name'"
            :label="$t('expenses_bank.localization_value.value')"
            v-bind:class="{'ui-no-valid': EX.validation.bank}"
            :errorTxt="$t(`${EX.validationTranslate.bank}.localization_value.value`)"
            :error="EX.validation.bank"
            @change="(val) => {EX.setBank(val)}"
            :selected="EX.data.bank"
        />
      </div>
    </div>

    <div class="section-label"
         v-bind:class="{'admin-edit-item': isAdmin || checkImpersonate()}">
      <div class="admin-edit" @click="editTranslate(['expenses_Documents'])"></div>
      {{$t('expenses_Documents.localization_value.value')}}
    </div>

    <div class="order-create__row custom-row"
         :key="images - 100"
    >
      <div class="custom-col custom-col--16 custom-col--md-50 custom-col--sm-100"
           v-for="(item, index) in EX.data.Files.data.downloadFiles"
           :key="index">
        <div class="site-document d-flex justify-content-center">
              <span class="site-document__remove" @click="removeDocument(item)">
                <CloseIcon/>
              </span>
          <div class="site-document__img">
            <img v-if="item.mime_type !== 'application/pdf'"
                 :src="`data:${item.type};base64,` + item.base64"
                 @click="showSingle(item.id + 1)"
                 alt="img"
            >
            <img v-else
                 @click="openPdf(item['base64'])"
                 style="width: 30px; height: 40px;"
                 src="/img/common/pdf_file_icon.svg"
                 alt="ico"
            >
          </div>
        </div>
      </div>

      <div class="order-create__col custom-col position-relative"
           v-if="EX.data.Files.data.maxCountFiles - Object.keys(EX.data.Files.data.downloadFiles).length > 0"
      >
        <DropZone class="drop-zone-bg"
                  :parentFiles="EX.data.Files.data.files"
                  :multiple="true"
                  :maxCount="EX.data.Files.data.maxCountFiles - EX.data.Files.data.downloadFiles.length"
                  :maxSize="EX.data.Files.data.maxSizeFiles"
                  :accept="'image/x-png,image/jpeg,'"
                  @changeImg="changeImg"
        />
        <div class="error-field ml-3" v-if="EX.data.Files.validation.files">
          {{$t('common_fileIsRequired.localization_value.value')}}
        </div>
      </div>
    </div>

    <Lightbox
        escDisabled
        moveDisabled
        :visible="visible"
        :imgs="imgs"
        :index="index"
        @hide="handleHide"
    ></Lightbox>

<!--    <div class="custom-row product-img-row"-->
<!--         v-if="Object.keys(EX.data.Files.data.downloadFiles).length > 0"-->
<!--         :key="images"-->
<!--    >-->
<!--      <div class="custom-col custom-col&#45;&#45;16 custom-col&#45;&#45;md-50 custom-col&#45;&#45;sm-100"-->
<!--           v-for="(file, indexFile) in EX.data.Files.data.downloadFiles"-->
<!--           :key="indexFile"-->
<!--      >-->
<!--        <div class="site-document d-flex justify-content-center">-->
<!--          <div class="site-document__remove" @click="removeDocument(parseInt(_.first(Object.keys(file))) + 1)">-->
<!--            <CloseIcon/>-->
<!--          </div>-->
<!--          <div class="site-document__img">-->
<!--            <img :src="'data:image/png;base64,' + file[_.first(Object.keys(file))]"-->
<!--                 @click="showSingle(_.first(Object.keys(file)))" alt="img">-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--    </div>-->
  </div>
</template>

<script>
  import InputSum from "../../../../UI/inputs/InputSum/InputSum";
  import TextareaDefault from "../../../../UI/textarea/TextareaDefault/TextareaDefault";
  import DropZone from "../../../../coreComponents/DropZone/DropZone";
  import DefaultSelect from "../../../../UI/selectiones/DefaultSelect/DefaultSelect";
  import CloseIcon from '../../../../../../public/img/modal-group/close-icon.svg?inline'
  // import {EXPENSES_SYSTEM_TYPES} from "../../../../../staticData/staticVariables";
  import DatePickerDefault from "../../../../UI/inputs/DatePickerDefault/DatePickerDefault";
  import DatePicker from 'vue2-datepicker'
  import Lightbox from "vue-easy-lightbox";

  export default {
    name: "StepA",
    components: {
      DatePickerDefault,
      DatePicker,
      DefaultSelect,
      DropZone,
      TextareaDefault,
      InputSum,
      CloseIcon,
      Lightbox,
    },

    props: {
      EX: Object,
      warehouses: Array,
      countries: Array,
      expenseTypes: Array,
      banks: Array,
      payees: Array,
    },

    data() {
      return {
        images: -1,
        imgs: [], // Img Url , string or Array of string
        visible: false,
        index: 0, // default: 0
      }
    },

    mounted() {
      // const query = new this.Query();
      // let url = '?';
      // let myQuery = query
      //   .for('posts')
      // url = url + myQuery.limit(100000).page(1).url().split('?')[1]
      // this.$store.dispatch('fetchExpensesTypes', url).then(response => {
      //   this.expensesTypes = this._.filter(this.getRespPaginateData(response), {type: EXPENSES_SYSTEM_TYPES.DEFAULT_TYPE.value})
      //   this.expensesPayees = this._.filter(this.getRespPaginateData(response), {type: EXPENSES_SYSTEM_TYPES.PAYEE_TYPE.value})
      // })
    },

    methods: {
      changeImg(files, maxSizeError) {
        this.EX.data.Files.setFiles(files)

        this.EX.data.Files.setFilesMaxSizeError(maxSizeError)
      },

      changeExpensesType(val){
        this.EX.setType(val)
        this.changeExpensesTypeChild('')
      },

      changeExpensesTypeChild(val){
        this.EX.setTypeChild(val)
      },

      changeExpensesPayee(val){
        this.EX.setPayee(val)
      },

      removeDocument(item) {
        let targetFile = item.id

        //delete big image
        if (item.type === 'small_image') {
          targetFile = item.id + 1
        }

        this.$store.dispatch('removeUserDocument', targetFile).then(() => {

          let files = this.EX.data.Files
          let updatedFiles = this._.remove(files.data.downloadFiles, function(n) {
            return n.id === item.id
          })
          files.getDownloadFiles(updatedFiles)
          this.images = item.id

        })
      },

      show() {
        this.visible = true
      },

      handleHide() {
        this.visible = false
      },

      showSingle(id) {
        this.$store.dispatch('getFileFromServer', id).then((response) => {
          this.imgs = []
          console.log(response);
          this.imgs.push({
            title: 'img',
            src: `data:image/png;base64,` + response[id]
          })
          this.show()
        }).catch(error => this.createErrorLog(error))
      },

      openPdf(base64) {
        this.globalOpenPdfBase64(base64)
      },
    },


  }
</script>

<style scoped>

</style>
